export const SITE_URL = "https://stirruphq.com";
export const SIGNUP_URL = "https://app.stirruphq.com/signup";
export const SIGNIN_URL = "https://app.stirruphq.com/signin";
export const DEMO_URL = "/contact?topic=demo";
export const SALES_URL = "/contact?topic=sales";

export const EMAILS = {
  sales: "sales@stirruphq.com",
  support: "support@stirruphq.com",
  security: "security@stirruphq.com",
  privacy: "privacy@stirruphq.com",
} as const;

export const COMPANY = "Stirrup, Inc.";

export type ModuleLink = {
  href: string;
  label: string;
  desc: string;
  icon: "Plug" | "Grid3x3" | "Braces" | "BarChart3" | "ShieldCheck" | "BookOpen" | "Search" | "Sparkles";
};

/** The eight modules, grouped the way the Product menu shows them. */
export const MODULE_GROUPS: { name: string; items: ModuleLink[] }[] = [
  {
    name: "Build",
    items: [
      { href: "/features/connections", label: "Connections & Files", desc: "Postgres, MySQL, REST, Sheets, Excel, uploads", icon: "Plug" },
      { href: "/features/spreadsheets", label: "Spreadsheets", desc: "Formulas that recalculate on live data", icon: "Grid3x3" },
      { href: "/features/scripts", label: "Scripts & APIs", desc: "JS, TS and SQL that publish as endpoints", icon: "Braces" },
      { href: "/features/graphs", label: "Graphs & Dashboards", desc: "Charts bound to live ranges", icon: "BarChart3" },
    ],
  },
  {
    name: "Govern & automate",
    items: [
      { href: "/features/contracts", label: "Contracts & Triggers", desc: "Quality rules, freshness, automation", icon: "ShieldCheck" },
      { href: "/features/documentation", label: "Docs & Doc Sites", desc: "Internal docs and public portals", icon: "BookOpen" },
      { href: "/features/investigate", label: "Investigate", desc: "Root-cause analysis across your data", icon: "Search" },
      { href: "/meet-juno", label: "Juno AI agent", desc: "An agent that uses your workspace tools", icon: "Sparkles" },
    ],
  },
];

export const MODULES: ModuleLink[] = MODULE_GROUPS.flatMap((g) => g.items);

/** Top-level nav items after the Product menu. */
export const NAV_LINKS = [
  { href: "/platform", label: "Platform" },
  { href: "/enterprise", label: "Enterprise" },
  { href: "/pricing", label: "Pricing" },
  { href: "/docs", label: "Docs" },
] as const;

export const FOOTER_COLUMNS: { title: string; links: { href: string; label: string }[] }[] = [
  {
    title: "Product",
    links: [...MODULES.map(({ href, label }) => ({ href, label })), { href: "/features", label: "All features" }],
  },
  {
    title: "Platform",
    links: [
      { href: "/platform", label: "Platform overview" },
      { href: "/enterprise", label: "Enterprise" },
      { href: "/security", label: "Security" },
      { href: "/see-the-difference", label: "Stirrup vs. your current stack" },
      { href: "/badge", label: "Stirrup Forms" },
    ],
  },
  {
    title: "Company",
    links: [
      { href: "/about", label: "About" },
      { href: "/pricing", label: "Pricing" },
      { href: "/contact", label: "Contact" },
      { href: "/docs", label: "Documentation" },
    ],
  },
  {
    title: "Legal",
    links: [
      { href: "/privacy", label: "Privacy policy" },
      { href: "/terms", label: "Terms of service" },
    ],
  },
];
